import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_side_bar = _resolveComponent("side-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_chat_dialog = _resolveComponent("chat-dialog")!
  const _component_set_template_dialog = _resolveComponent("set-template-dialog")!
  const _component_set_details_dialog = _resolveComponent("set-details-dialog")!
  const _component_set_report_dialog = _resolveComponent("set-report-dialog")!
  const _component_transaction_dialog = _resolveComponent("transaction-dialog")!
  const _component_detailed_report_dialog = _resolveComponent("detailed-report-dialog")!
  const _component_set_chatbot_dialog = _resolveComponent("set-chatbot-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_side_bar),
    _createVNode(_component_router_view, { style: {"width":"100%","overflow-y":"auto"} }, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: _ctx.$route.path
            }))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    _createVNode(_component_chat_dialog),
    _createVNode(_component_set_template_dialog),
    _createVNode(_component_set_details_dialog),
    _createVNode(_component_set_report_dialog),
    _createVNode(_component_transaction_dialog),
    _createVNode(_component_detailed_report_dialog),
    _createVNode(_component_set_chatbot_dialog)
  ], 64))
}